<template>
  <span v-tooltip="tip">
    <slot></slot>
    <i v-if="tip && showIcon" class="fas fa-info-circle"></i>
  </span>
</template>

<script>
export default {
  name: 'InfoTip',
  props: {
    tip: {
      type: String,
      required: false,
      default: ''
    },
    showIcon: {
      type: Boolean,
      required: false,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  i {
    cursor: pointer;
    opacity: 0.8;
    transition: opacity .5s ease-in-out;

    &:hover {
      opacity: 1;
    }
  }
</style>